/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import toast from "react-hot-toast";
import { getEnvs } from "state/EnvironmentsContext/EnvContext";
import { sentryCaptureError } from "./errorFormatter";

const warning = (error: any) => {
  if (getEnvs((state) => state.environment) === "development") {
    console.log("######CAUGHT ERROR######");
    sentryCaptureError(error);
    if (error?.hasOwnProperty("isCustom") && error?.isCustom === true) {
      console.warn(error?.error);
      console.groupCollapsed("Stack trace");
      console.warn(Error(error?.stack));
      console.groupEnd();
    } else {
      toast.error("Dear developer, please check the console for some fun.");
      console.warn(
        Error(error?.stack ?? error?.message ?? JSON.stringify(error, null, 2)),
      );
    }

    console.log("^^^^^^^^^^^^^^^^^^^^^^^");
  }
};

export default warning;
